var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 39,
    viewBox: "0 0 43 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6667 21.6364C32.88 21.6364 35.4849 19.0315 35.4849 15.8182C35.4849 12.6049 32.88 10 29.6667 10C26.4534 10 23.8485 12.6049 23.8485 15.8182C23.8485 19.0315 26.4534 21.6364 29.6667 21.6364ZM26.5584 22.7878C22.4365 22.0455 19 26.3497 19 30.5378C19 34.726 22.3951 38.1212 26.5833 38.1212H34.6893C38.8775 38.1212 42.2727 34.726 42.2727 30.5378C42.2727 26.3497 38.8576 22.2056 34.7031 22.7353C34.3175 22.7844 33.9323 22.8556 33.5454 22.9545C30.7936 23.6581 30.4791 23.7385 27.3341 22.9545C27.0681 22.8882 26.81 22.8331 26.5584 22.7878Z",
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 11.6364C13.88 11.6364 16.4849 9.0315 16.4849 5.8182C16.4849 2.6049 13.88 0 10.6667 0C7.4534 0 4.8485 2.6049 4.8485 5.8182C4.8485 9.0315 7.4534 11.6364 10.6667 11.6364ZM7.5584 12.7878C3.4365 12.0455 0 16.3497 0 20.5378C0 24.726 3.3951 28.1212 7.5833 28.1212H15.6893C19.8775 28.1212 23.2727 24.726 23.2727 20.5378C23.2727 16.3497 19.8576 12.2056 15.7031 12.7353C15.3175 12.7844 14.9323 12.8556 14.5454 12.9545C11.7936 13.6581 11.4791 13.7385 8.3341 12.9545C8.0681 12.8882 7.81 12.8331 7.5584 12.7878Z",
    fill: "#3E3E3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.0928b1b9a0729dab10bb8d37c9a08c61.svg";
export { ForwardRef as ReactComponent };